import React from 'react';

import CountryInfo from '../CountryInfo';

const PACKAGE_SECTION = {
    title: 'Economic Stimulus Package',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">Details</p>
            <ul>
                <li>
                    100 billion euros ($110 billion) of guarantees for company
                    loans
                </li>
                <li>
                    17 billion euros of direct aid to keep firms afloat during
                    the lockdown
                </li>
                <li>83 billion euros from a private investment</li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'Spain to Allocate as Much as $219 Billion in Virus Aid',
            url: 'https://finance.yahoo.com/news/spain-allocate-much-219-billion-154554834.html',
        },
    ],
};

const BANK_SECTION = {
    title: 'Banco Santander Spain Loan',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">Details</p>
            <ul>
                <li>
                    Liquidity facility in pre-approved loans amounting to 20
                    billion euros ($22.8 billion), with interest due within one
                    year, for SMEs and self-employed workers.
                </li>
                <li>More flexibility in cash flow management.</li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'Santander Spain offers SMEs and self-employed workers a 20 billion pre-approved loans facility to mitigate the possible impact of the coronavirus outbreak',
            url: 'https://www.santander.com/en/press-room/press-releases/santander-spain-offers-smes-and-self-employed-workers-a-20-billion-pre-approved-loans-facility-to-mitigate-the-possible-impact-of-the-coronavirus-outbreak',
        },
    ],
};

const COUNTRY_INFO = {
    countryName: 'Spain',
    lastUpdated: 'March 18, 2020',
    introSection: (
        <p>
            Spain has multiple different financial assistance options available.
            Please look over this information and follow up as appropriate.
        </p>
    ),
    sections: [PACKAGE_SECTION, BANK_SECTION],
};

const SpainInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default SpainInfo;
